import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

async function fetchProvidersCount(spaceId: string) {
  const { count, error } = await apiClient
    .from('providers')
    .select('id', { count: 'exact', head: true })
    .eq('space_id', spaceId);

  if (error) {
    throw error;
  }

  return count ?? 0;
}

/** Number of providers in the current space, without loading them. */
export function useGetProvidersCount() {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.getProvidersCount(currentSpace?.id ?? ''),
    queryFn: () => fetchProvidersCount(currentSpace!.id),
    enabled: !!currentSpace?.id,
    staleTime: _3_DAYS,
  });
}
